export default "__VITE_ASSET__BSdu0udI__"